module.exports = __webpack_public_path__ + "img/oufu_70x100x10b.prt.a4f72f69.jpg";